import React from 'react';
import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
// import store from 'app/store';
import { Point } from '../../../../libs/map/drive/Point';
import InputPoint from './InputPointRender';

export default React.memo(function LitePointsListItem(props) {
  const dataPoints = useSelector(
    (store) => store.tourFullData.activeMultiPart.points
  );

  const activePointId = useSelector(
    (store) => store.tourFullData.activePointId
  );

  const pointListLength = props.pointList ? props.pointList.length : 0;

  const fetching = useSelector((store) => store.tourFullData.fetching);

  const dataPointId = useSelector((store) => store.tourFullData.dataPoint.id);

  const {
    edit,
    userHomeAs,
    changeCursorWrapperClassName,
    setWorkAddressUser,
    setHomeAddressUser,
    currentLocation,
    workAddress,
    homeAddress,

    InputSuffix,
    addPoint,
    convertToVia,
    convertToDrag,
    itemClickHandler,
    itemOverHandler,
    setSelectedPoint,
    getClassForSelect,
    moveCard,
    dragEnd,
    deletePoint,
    setSelectedAutocomplete,
    convertStartToHome,
    convertEndToHome,
    checkWrongPointPosition,
  } = props;

  if (
    !fetching &&
    dataPoints &&
    dataPoints.length &&
    typeof dataPoints.map === 'function'
  ) {
    return dataPoints.map((point, i) => {
      //eslint-disable-line
      if (edit || point.type !== Point.Type.DRAG) {
        return (
          <InputPoint
            point={point}
            key={`${point.id}${point.address}`}
            index={i}
            edit={edit}
            activePointId={activePointId}
            dataPointId={dataPointId}
            InputSuffix={InputSuffix}
            addPoint={addPoint}
            convertToVia={convertToVia}
            convertToDrag={convertToDrag}
            itemClickHandler={itemClickHandler}
            itemOverHandler={itemOverHandler}
            setSelectedPoint={setSelectedPoint}
            getClassForSelect={getClassForSelect}
            moveCard={moveCard}
            dragEnd={dragEnd}
            deletePoint={deletePoint}
            setSelectedAutocomplete={setSelectedAutocomplete}
            convertStartToHome={convertStartToHome}
            convertEndToHome={convertEndToHome}
            checkWrongPointPosition={checkWrongPointPosition}
            pointListLength={pointListLength}
            homeAddress={homeAddress}
            workAddress={workAddress}
            currentLocation={currentLocation}
            setHomeAddressUser={setHomeAddressUser}
            setWorkAddressUser={setWorkAddressUser}
            changeCursorWrapperClassName={changeCursorWrapperClassName}
            userHomeAs={userHomeAs}
          />
        );
      }
      return null;
    });
  }
  if (dataPoints) {
    return <Skeleton title={false} paragraph={{ rows: 5 }} active />;
  }
  return null;
});
